import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=7127c6b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.2.2_@vue+compiler-sfc@3.0.0-alpha.11_vue@3.2.13_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7127c6b4"]])

export default __exports__